import type { ApiCustomerContactRole, ApiCustomerContactMutationData, ApiCustomerDetail, ApiCustomerLocationCapacityRow, ApiCustomerUser } from "api-client";
import type { CustomerContactRow, CustomerContactsListQuery } from "design-components";
import { defaultCustomerContactsListQuery } from "design-components";

export type { CustomerContactRow, CustomerContactsListQuery };

export interface CustomerDetailState {
  customer: ApiCustomerDetail | null;
  users: ApiCustomerUser[];
  locations: ApiCustomerLocationCapacityRow[];
  /** Active Locations & Capacity search term (server-side). */
  locationsSearch: string;
  /** True after an unfiltered locations fetch returned ≥1 row (or associate added one). */
  locationsCanSearch: boolean;
  contacts: CustomerContactRow[];
  contactsTotalCount: number;
  contactRoles: ApiCustomerContactRole[];
  contactsListQuery: CustomerContactsListQuery;
  contactsLoading: boolean;
  contactsError: string | null;
  contactsDeleting: boolean;
  contactFormSubmitting: boolean;
  contactEditLoading: boolean;
  contactEditContactId: number | null;
  contactEditDetail: ApiCustomerContactMutationData | null;
  loading: boolean;
  locationsLoading: boolean;
  error: string | null;
  locationsError: string | null;
  selectedCustomerId: string | null;
  statusSubmitting: boolean;
  userInviteSubmitting: boolean;
  logoUploading: boolean;
}

export const customerDetailInitialState: CustomerDetailState = {
  customer: null,
  users: [],
  locations: [],
  locationsSearch: "",
  locationsCanSearch: false,
  contacts: [],
  contactsTotalCount: 0,
  contactRoles: [],
  contactsListQuery: defaultCustomerContactsListQuery(),
  contactsLoading: false,
  contactsError: null,
  contactsDeleting: false,
  contactFormSubmitting: false,
  contactEditLoading: false,
  contactEditContactId: null,
  contactEditDetail: null,
  loading: false,
  locationsLoading: false,
  error: null,
  locationsError: null,
  selectedCustomerId: null,
  statusSubmitting: false,
  userInviteSubmitting: false,
  logoUploading: false,
};
